// extracted by mini-css-extract-plugin
export default {"vpView":"VPView_vpView__Osnq-"};